import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { DollarSign } from "lucide-react";
import { useCashflowSignal } from "@/hooks/useCashflowSignal";
import { CASHFLOW_SIGNAL_COLORS } from "@/lib/statusMaps";

/**
 * Compact cashflow signal badge for TopNav.
 * Only visible when signal is AMBER or RED.
 * Links to /planning/finance for details.
 */
export default function CashflowSignalBanner() {
  const { signal, isLoading } = useCashflowSignal();

  // Don't show when GREEN (normal operations) or loading
  if (isLoading || signal === "GREEN") return null;

  return (
    <Link to="/planning/finance" className="no-underline">
      <Badge className={`${CASHFLOW_SIGNAL_COLORS[signal] ?? ""} cursor-pointer gap-1`}>
        <DollarSign className="h-3 w-3" />
        {signal}
      </Badge>
    </Link>
  );
}
